const MACROREGION_ADDRESSES: Record<string, string> = {
	'São Paulo': 'Rua Urussuí, 56 - Itaim Bibi, São Paulo - SP',
	Alphaville: 'Alphaville Empresarial - Barueri, SP',
	Interior: 'Condomínio Fazenda Boa Vista - Porto Feliz, SP',
	'Litoral Norte': 'Baleia - São Sebastião, SP',
	'Litoral Sul': 'Jardim Acapulco - Guarujá, SP',
	Curitiba: 'Rua XV de Novembro, 1000 - Centro, Curitiba - PR'
};

export interface GeocodeResult {
	center?: google.maps.LatLng;
	bounds?: google.maps.LatLngBounds;
}

export function buildLocationAddress(
	region: string,
	city: string,
	state: string
): string {
	const parsedRegion = region ? `${region} -` : '';

	if (
		parsedRegion === 'São Paulo, SP' ||
		(!parsedRegion && city === 'São Paulo')
	) {
		return MACROREGION_ADDRESSES['São Paulo']!;
	}

	if (
		parsedRegion === 'Curitiba, PR' ||
		(!parsedRegion && city === 'Curitiba')
	) {
		return MACROREGION_ADDRESSES['Curitiba']!;
	}

	return `${parsedRegion} ${city}, ${state}`;
}

export async function geocodeAddress(address: string): Promise<GeocodeResult> {
	if (import.meta.server) return {};

	return new Promise(resolve => {
		const geocoder = new google.maps.Geocoder();

		geocoder.geocode({ address, region: 'BR' }, (results, status) => {
			const result = results?.[0];

			if (status === 'OK' && result) {
				resolve({
					center: result.geometry.location,
					bounds: result.geometry.bounds
				});
			} else {
				resolve({});
			}
		});
	});
}

export function getMacroregionAddress(macroregion: string): string | undefined {
	return MACROREGION_ADDRESSES[macroregion];
}
